import SendbirdChat from "@sendbird/chat";
import { GroupChannelModule, SendbirdGroupChat } from "@sendbird/chat/groupChannel";

let sendbirdInstance: SendbirdGroupChat | null = null;

function getSendbirdConfig(): { app_id: string } | null {
    return window.pgSendbirdConfig ?? null;
}

/**
 * Returns the Sendbird Chat instance, initializing with GroupChannelModule if needed.
 */
export async function getSendbird(): Promise<SendbirdGroupChat> {
    if (!sendbirdInstance) {
        const config = getSendbirdConfig();

        if (!config?.app_id) {
            throw new Error("Sendbird App ID is not configured.");
        }

        sendbirdInstance = SendbirdChat.init({
            appId: config.app_id,
            modules: [new GroupChannelModule()],
        }) as SendbirdGroupChat;
    }
    return sendbirdInstance;
}